import styled from "styled-components"

export const RecentIngredientsWrapper = styled.div`
  height: calc(100% - var(--input-height));
  overflow: hidden;
`

export const Title = styled.div`
  line-height: 22px;
  font-size: 14px;
  font-weight: 700;
  padding: 8px var(--app-horizontal-padding);
`

export const RecentIngredientsContent = styled.div`
  --title-height: 22px;
  overflow-y: auto;
  height: calc(100% - var(--title-height));
  padding: 0 var(--app-horizontal-padding);
`

export const IngredientDivider = styled.div`
height: 1px;
background: var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
width: 100%;

@supports (-webkit-touch-callout: none) {
  height: 0.8px;
`

export const NoRecentIngredientDescription = styled.p`
  font-weight: 600;
  line-height: 160%;
`
